import React from "react";
import { useSelector } from "react-redux";
import showdown from "showdown";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  const converter = new showdown.Converter();
  const subtitle = converter.makeHtml(
    currentActivity.websiteData.keySteps.subtitle
  );
  return (
    currentActivity &&
    currentActivity.websiteData &&
    currentActivity.websiteData.keySteps.data.length > 0 && (
      <div
        id="program"
        className="gradiant-background pwg-section section steps-section"
      >
        <div className="container">
          <div className="section-head heading-light text-center ">
            <div className="row mb-60">
              <div className="col-md-8 col-md-offset-2">
                <h2 className="heading whitetxt heading-light">
                  {currentActivity.websiteData.keySteps.title
                    ? currentActivity.websiteData.keySteps.title
                    : "Les étapes clés"}
                </h2>
                {currentActivity.websiteData.keySteps.subtitle && (
                  <p
                    className="h4 heading-light"
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                  />
                )}
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {currentActivity.websiteData.keySteps.data.map((ks, i) => {
                return (
                  <div
                    className="col-12 col-md-3 d-flex mb-6 px-0"
                    // style={{ alignItems: "center" }}
                  >
                    <div className="text-center" style={{ width: "60%" }}>
                      <div
                        className="black d-inline-block mb-3 px-5 py-4"
                        style={{ border: "0.4px solid #bdbdbd" }}
                      >
                        {i + 1}
                      </div>
                      <p
                        className="black"
                        style={{
                          fontWeight: 800,
                          margin: "auto",
                        }}
                      >
                        {ks.title}
                      </p>
                      {ks.dates.start.day && (
                        <p
                          className="black"
                          style={{
                            fontStyle: "italic",
                            margin: "auto",
                          }}
                        >
                          {ks.dates.start.day} {ks.dates.start.month}
                          {ks.dates.start.day && ks.dates.end.day ? " - " : ""}
                          {ks.dates.end.day} {ks.dates.end.month}
                        </p>
                      )}
                    </div>
                    {(i + 1) % 4 !== 0 &&
                      i + 1 !==
                        currentActivity.websiteData.keySteps.data.length && (
                        <div
                          className="mt-5"
                          style={{
                            width: "40%",
                            height: 1,
                            backgroundColor: " #bdbdbd ",
                          }}
                        />
                      )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    )
  );
};
